import {AppState} from '../reducerType';

export const selectUpdateDataFromApi = (state: AppState): boolean => state.page.updateDataFromApi;
export const selectClassName = (state: AppState) => state.page.className;